import React from "react"
import { FiPlus } from "react-icons/fi"

import Modal from "~components/Modal"

import Credentials from "./Credentials"
import CreateAppModal from "./CreateAppModal"

import * as style from "./style.module.scss"

const AppButton = ({
  app, modal, onToggleModal, children, ...props
}) => (
  <div className={style.wrapper}>
    {app.created ? (
      <Credentials {...props} />
    ) : (
      <>
        <button className={style.button} onClick={onToggleModal} type="button">
          {children}
          <FiPlus />
        </button>
        <Modal show={modal.show} onClose={onToggleModal}>
          <CreateAppModal {...props} onToggleModal={onToggleModal} />
        </Modal>
      </>
    )}
  </div>
)

export default AppButton
